/* eslint-disable no-console */

/**
 * Developer Note:
 * If you wanna get the exact console.trace of certain
 * actions, put the action type strings in here; otherwise
 * the console gets insanely noisy if we're console.trace()
 * on EVERY dispatched action!
 */
const TRACE_ACTIONS = ["dev/testActionToWatch"];

export const actionLogger = (_store) => (next) => async (action) => {
  const { payload, type } = action;
  const start = performance.now();
  let result = await next(action);
  const end = performance.now();
  const diff = (end - start).toFixed(2);

  console.group(`%c ${type}`, "color: #f69125;");
  console.log(`%c ⏲️ ${action.type}, took ${diff}ms`, "color: #fde9cd;");
  console.log("%c payload", "font-weight: bold;", payload);
  if (TRACE_ACTIONS.includes(type)) {
    console.trace();
  }
  console.groupEnd();

  return result;
};
